import React from 'react'

import HomeAndVillasBookedItemCard from './HomeAndVillas/HomeAndVillasBookedItemCard'
import HomeAndVillasBookmarkItemCard from './HomeAndVillas/HomeAndVillasBookmarkItemCard'
import { ItemCardVariant } from './ItemCard'
import TripSummaryCardLoadingSkeleton from '../TripSummary/TripSummaryCardLoadingSkeleton'

import { isVillaOffer } from 'lib/offer/offerTypes'
import { useOffer } from 'tripPlanner/hooks/api'
import { HomeAndVillasItem } from 'tripPlanner/types/tripItem'
import { isLeBookmark } from 'tripPlanner/utils'

interface Props {
  item: HomeAndVillasItem
  onClickCard: (offerLink: string) => void
  onClickTripName?: () => void
  variant: ItemCardVariant
}

function HomeAndVillasItemCard({
  item,
  onClickCard,
  onClickTripName,
  variant,
}: Props) {
  const { data: offer, isLoading } = useOffer(item.code)
  if (isLoading) {
    return <TripSummaryCardLoadingSkeleton />
  }
  if (isVillaOffer(offer)) {
    if (isLeBookmark(item)) {
      return (
        <HomeAndVillasBookmarkItemCard
          offer={offer}
          item={item}
          onClickCard={onClickCard}
          onClickTripName={onClickTripName}
          variant={variant}
        />
      )
    } else {
      return (
        <HomeAndVillasBookedItemCard
          offer={offer}
          item={item}
          onClickTripName={onClickTripName}
          variant={variant}
        />
      )
    }
  }
  return null
}

export default HomeAndVillasItemCard
